import styled from 'styled-components'
import CustomButton from '@/shahrzad-assets/shared_components/CustomButton'
import { buttonTypes } from '@/shahrzad-assets/shared-constants/buttonTypes'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { fontSize, fontsWeight } from '@/shahrzad-assets/shared-constants/fonts'
import { icons } from '@/shahrzad-assets/shared-asstes/icons'

interface IProps {
  title: string
  description: string
  icon: string
  hasButton: boolean
  has2Button: boolean
  buttonText: string
  button2Text: string
  buttonClick(): any
  button2Click(): any
}
const ErrorSection = ({
  title,
  description,
  icon = icons.EMPTY_FOLDER,
  hasButton,
  has2Button,
  buttonText,
  button2Text,
  buttonClick,
  button2Click,
}: Partial<IProps>) => {
  return (
    <ErrorContainer>
      <img src={icon} alt='error-icon' />
      <h2>{title}</h2>
      <p>{description}</p>
      {hasButton && (
        <CustomButton
          width='100%'
          height={dimens.BUTTON_LARGE_HEGHIT}
          styletype={buttonTypes.PRIMARY_FILL}
          onClick={buttonClick}
        >
          {buttonText}
        </CustomButton>
      )}
      {has2Button && (
        <ButtonTwo
          width='100%'
          height={dimens.BUTTON_LARGE_HEGHIT}
          styletype={buttonTypes.PRIMARY_OUTLINE}
          onClick={button2Click}
        >
          {button2Text}
        </ButtonTwo>
      )}
    </ErrorContainer>
  )
}

export default ErrorSection

const ErrorContainer = styled.div`
  /* width: fit-content; */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  h2 {
    font-size: ${fontSize.LARGE};
    font-family: ${fontsWeight.BOLD};
    margin: ${dimens.SPACING_M} 0 ${dimens.SPACING_S};
  }
  p {
    font-size: ${fontSize.NORMAL};
    margin-bottom: ${dimens.SPACING_M};
  }
`
const ButtonTwo = styled(CustomButton)`
  margin-top: ${dimens.SPACING_XS};
`
